import React from "react";
import "../css/Footer1.css";

const Footer1 = () => {
  return (
    <footer className="footer-unique">

      {/* CENTER WATERMARK LOGO */}
      <div className="footer-logo-watermark">ACE FITNESS</div>

      {/* CIRCULAR NAV AROUND LOGO */}
      <div className="footer-arc-nav">
        <a href="/">Home</a>
        <a href="/plans">Membership</a>
        <a href="/workouts">Workouts</a>
        <a href="/trainers">Trainers</a>
        <a href="/gallery">Gallery</a>
        <a href="/contact">Contact</a>
        <a href="/faqs">FAQs</a>
        <a href="/services">Services</a> {/* ADDED */}
      </div>

      {/* FLOATING SOCIAL STRIP */}
      <div className="footer-social-strip">
        <a href="#">Instagram</a>
        <a href="#">YouTube</a>
        <a href="#">WhatsApp</a>
      </div>

      {/* BOTTOM LINE */}
      <div className="footer-bottom">
        © 2025 ACE FITNESS — All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer1;
